import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  DxButtonModule,
  DxDropDownButtonModule,
  DxSelectBoxModule,
  DxTabsModule,
  DxToolbarModule,
  DxTooltipModule
} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {TebDonemService} from "../../../../../../../teb/src/lib/shared/services/teb-donem.service";
import {
  ButtonWithIconObject,
  DkNavService,
  DynamicButton,
  FormDto,
  PanelItem,
  ScreenService
} from "@dabnet-kamu/libs/ui";
import Button from "devextreme/ui/button";
import {TamEkranService} from "../../../services/tam-ekran.service";
import {TamEkranDugmesiComponent} from "../tam-ekran-dugmesi/tam-ekran-dugmesi.component";
import {YardimDugmesiComponent} from "../yardim-dugmesi/yardim-dugmesi.component";


@Component({
  selector: 'dk-list-header',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxDropDownButtonModule, DxSelectBoxModule, DxTabsModule, DxToolbarModule, DxiItemModule, DxTooltipModule, TamEkranDugmesiComponent, YardimDugmesiComponent],
  templateUrl: './list-header.component.html',
  styleUrls: ['./list-header.component.scss'],
})
export class ListHeaderComponent implements OnInit, OnDestroy {
  @Input() headerText: string;
  @Input() pageData: any;
  @Input() disable: boolean;
  @Input() tabWidth: any;
  @Input() hideCloseButton: boolean;
  @Input() disableDonem: boolean;
  @Input() locateInMenu: boolean = true;
  @Input() public twoLineEnable: boolean = false

  @Input() donemAktif = true;
  @Input() ambarAktif = true;
  @Input() selectedPeriodId!: number;
  @Input() actionMenuElement: any[];
  @Input() formMetaData?: FormDto;
  @Input() selectBoxConfig: {
    donemDataSource: any[];
    valueExpr: string;
    displayExpr: string;
    width?: any
  };
  @Input() newAddMenuElement!: any[];
  @Input() selectedPanelItems: Array<any>;
  @Input() panelItems: Array<PanelItem>;
  @Input() dynamicButtons: DynamicButton[];
  @Input() headerNewButton: ButtonWithIconObject;
  @Input() panelItemPosition: any = 'center';
  @Input() newAddMenuText: string;
  @Output() handlePeriodChange = new EventEmitter<any>();
  @Output() showAdd = new EventEmitter<void>();
  @Output() closePage = new EventEmitter<void>();
  @Output() dynamicButtonClicked = new EventEmitter<void>();
  @Output() selectedPanelItemChanged = new EventEmitter<any>();
  @Output() onIslemItemClick = new EventEmitter<any>(); // Add this line
  @Output() onNewAddMenuClick = new EventEmitter<any>(); // Add this line
  closeButton: ButtonWithIconObject = {name: 'Kapat'};
  showDynamicButtons = true;

  constructor(public tebDonemService: TebDonemService, public screen: ScreenService,
              private navService: DkNavService, public tamEkran: TamEkranService, public el: ElementRef<HTMLElement>) {
  }

  ngOnInit() {
    this.tamEkran.kaydol(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.tamEkran.ayril(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['dynamicButtons']) {
      if (this.dynamicButtons) this.showDynamicButtons = true;
      else this.showDynamicButtons = false;
    }
  }


  handleItemClick(event: any) {
    this.onIslemItemClick.emit(event); // Emit the onItemClick event
  }

  handleNewAddClick(event: any) {
    this.onNewAddMenuClick.emit(event); // Emit the onItemClick event
  }

  handleDynamicButtonClick(dynamicButton: any) {
    if (!dynamicButton.disabled) this.dynamicButtonClicked.emit(dynamicButton)
  }


  closePageButton($event: any) {
    if (this.pageData) {
      this.navService.closeButtonHandler(this.pageData)
    } else {
      this.closePage.emit()
    }

  }

  trackByFn(index: number, item: any): any {
    return item.id; // Eğer her butonun benzersiz bir 'id'si varsa onu kullanın
  }

  onContentReady(e: any) {
    let buttonElement = e.element.querySelectorAll(
      ".dx-toolbar-menu-container .dx-dropdownmenu-button"
    )[0];

    let buttonInstance = Button.getInstance(buttonElement);

    buttonInstance?.option("icon", "menu");
    buttonInstance?.option("hint", "Diğer İşlemler"); // tooltip
  }

}
